import envCheckers from 'utils/envCheckers';
import { dashIfEmpty } from 'utils/empty';

// interface OpusData {
//   bookingNo: string;
//   bookingStatusCode: string;
//   splitInfo: string;
//   siKind: string;
//   esiFlag: string;
//   siSource: string;
//   IRQD_I: string;
//   IRQD_R: string;
//   IRQD_Q: string;
//   IRQD_D: string;
//   returnStatus: string;
//   // podCode: string,
//   // delCode: string,
//   // consigneeName: string,
//   sailingDueDate: string;
//   srAmendSequence: string;
//   dgFlag: string;
//   shipperName: string;
// }

// interface ShineData {
//   bookingNo: string;
//   bookingStatusCode: string;
//   bookingStatusDescription: string;
//   srNumber: string;
//   splitInfo: string;
//   siKind: string;
//   siSource: string;
//   shipperName: string;
//   srAmendSequence: string;

//   countryPOL: string;
//   CRD: string;
//   porCode: string;
//   porName: string;
//   polCode: string;
//   polName: string;
//   podCode: string; //
//   podName: string;
//   delCode: string; //
//   delName: string;
//   vslCode: string;
//   vslNumber: string;

//   internalRemark: string;
//   consigneeCode: string;
//   consigneeName: string; //
//   rfFlag: string;
//   notifyCode: string;
//   notifyNumber: string;
// }

export interface BookingInfoDataResI {
  bookingNo: string;
  bookingStatusCode: string;
  splitInfo: string;
  siKind: string;
  esiFlag: string;
  dgFlag: string;
  siSource: string;
  IRQD_I: string;
  IRQD_R: string;
  IRQD_Q: string;
  IRQD_D: string;
  returnStatus: string;
  // podCode: string,
  // delCode: string,
  // shipperName: string,
  // consigneeName: string,
  sailingDueDate: string;

  bookingStatusDescription: string;
  srNumber: string;
  shipperName: string;
  srAmendSequence: string;

  countryPOL: string;
  CRD: string;
  porCode: string;
  porName: string;
  polCode: string;
  polName: string;
  podCode: string; //
  podName: string;
  delCode: string; //
  delName: string;
  vslCode: string;
  vslNumber: string;

  internalRemark: string;
  consigneeCode: string;
  consigneeName: string; //
  rfFlag: string;
  notifyCode: string;
  notifyNumber: string;

  container: any;
  volume: { cntrQty: string }[];
}

export interface BookingInfoBookingsResI {
  bookingNo: string;
  data: BookingInfoDataResI;
  opusError: boolean;
  opusFound: boolean;
  shineError: boolean;
  shineFound: boolean;
}
export interface BookingInfoResI {
  bookings: BookingInfoBookingsResI[];
  opusFields: string[];
  shineFields: string[];
}

export class BookingInfo {
  bookingInfo?: BookingInfoDataResI;
  opusError = false;
  opusFound = false;
  shineError = false;
  shineFound = false;
  opusFields = [] as string[];
  shineFields = [] as string[];

  bookingStatusCode?: string;
  splitInfo?: string;
  esiFlg?: string;
  dgFlag?: string;
  siSource?: string;
  siKind?: string;
  IRQD_I?: string;
  IRQD_R?: string;
  IRQD_Q?: string;
  IRQD_D?: string;
  returnStatus?: string;
  polCode?: string;
  podCode?: string;
  CRD?: string;
  internalRemark?: string;
  container?: any;

  rfFlag?: string;
  awkFlag?: string;
  bbFlag?: string;
  volume?: string;
  shipperName?: string;

  constructor(bookingInfoRes: BookingInfoResI) {
    let booking;
    if (
      bookingInfoRes.bookings &&
      bookingInfoRes.bookings.length > 0
    ) {
      booking = bookingInfoRes.bookings[0];
      this.bookingInfo = booking.data;
    }

    this.opusError = booking?.opusError;
    this.opusFound = booking?.opusFound;
    this.shineError = booking?.shineError;
    this.shineFound = booking?.shineFound;

    this.bookingStatusCode = this.bookingInfo?.bookingStatusCode;
    this.splitInfo = this.bookingInfo?.splitInfo;
    this.esiFlg = this.bookingInfo?.esiFlag;
    this.dgFlag = this.bookingInfo?.dgFlag;
    this.siSource = this.bookingInfo?.siSource;
    this.siKind = this.bookingInfo?.siKind;

    this.IRQD_I = this.bookingInfo?.IRQD_I;
    this.IRQD_R = this.bookingInfo?.IRQD_R;
    this.IRQD_Q = this.bookingInfo?.IRQD_Q;
    this.IRQD_D = this.bookingInfo?.IRQD_D;

    this.returnStatus = this.bookingInfo?.returnStatus;
    this.polCode = this.bookingInfo?.polCode;
    this.podCode = this.bookingInfo?.podCode;
    this.CRD = this.bookingInfo?.CRD;
    this.internalRemark = this.bookingInfo?.internalRemark;
    this.rfFlag = this.bookingInfo?.rfFlag;
    this.container = this.bookingInfo?.container;
    this.shipperName = this.bookingInfo?.shipperName;

    const sumVolume =
      (this.bookingInfo?.volume || [])
        .map((v) => v.cntrQty)
        .reduce(
          (previousValue, currentValue) =>
            Number(previousValue) + Number(currentValue),
          0,
        ) || 0;

    this.volume = sumVolume > 0 ? String(sumVolume) : undefined;
    // just for a debug
    if (this.container) {
      console.debug(
        `********************* found container in the bookingInfo ${this.container}`,
      );
    }
  }

  isFieldError(field: string) {
    return this.errorFields && this.errorFields.includes(field);
  }

  get hasInfoPanel(): boolean {
    return this.found || this.failedFromAnyApi;
  }

  get fields() {
    return [
      {
        dataKey: 'bkgStsCd',
        label: 'Booking Status',
        value: this.bookingStatus, // already mapped
      },
      {
        dataKey: 'esiFlg',
        label: 'ESI',
        value: this.ESI,
      },
      {
        dataKey: 'siSource',
        label: 'SRC(Source)',
        value: this.siSourceStr,
      },
      {
        dataKey: 'siKind',
        label: 'SI Kind:',
        value: this.siKind,
      },
      {
        dataKey: 'splitInfo',
        label: 'Split',
        value: this.splitInfo,
        useCustomRender: true, // add button for use the split value in the ticket's isSplit
      },
      {
        dataKey: 'shipperName',
        label: 'Shipper Name',
        value: this.shipperName,
      },
      {
        dataKey: 'dgFlag',
        label: 'DG Shipment',
        value: this.dgShipment,
      },
      // something
      {
        label: 'IRQD Status',
        subfields: [
          {
            dataKey: 'IRQD_I',
            label: 'I',
            value: this.IRQD_I,
          },
          {
            dataKey: 'IRQD_R',
            label: 'R',
            value: this.IRQD_R,
          },
          {
            dataKey: 'IRQD_Q',
            label: 'Q',
            value: this.IRQD_Q,
          },
          {
            dataKey: 'IRQD_D',
            label: 'D',
            value: this.IRQD_D,
          },
        ],
      },
      {
        dataKey: 'returnStatus',
        label: 'Return',
        value: this.returnStatus,
      },
      {
        dataKey: 'polCode',
        label: 'POL',
        value: this.polCode,
      },
      {
        dataKey: 'podCode',
        label: 'POD',
        value: this.podCode,
      },
      {
        dataKey: 'CRD',
        label: 'CRD',
        value: this.CRD,
      },
      {
        dataKey: 'internalRemark',
        label: 'Internal Remark',
        value: this.internalRemark,
      },
      {
        dataKey: 'rfFlag',
        label: 'Reefer',
        value: BookingInfo.formatYN(this.rfFlag),
      },
      {
        dataKey: 'awkFlag',
        label: 'Awk Flag',
        value: BookingInfo.formatYN(this.awkFlag),
      },
      {
        dataKey: 'bbFlag',
        label: 'BB Flag',
        value: BookingInfo.formatYN(this.bbFlag),
      },
      {
        dataKey: 'volume',
        label: 'Volume',
        value: this.volume,
      },
      {
        dataKey: 'container',
        label: 'Container',
        value: this.formattedContainer,
        useCustomRender: true,
      },
    ].map((field) => {
      if (!field.subfields) {
        return {
          ...field,
          value: dashIfEmpty(field.value),
          isError: this.isFieldError(field.dataKey),
        };
      } else {
        return {
          ...field,

          subfields: field.subfields.map((subfield) => ({
            ...subfield,
            value: dashIfEmpty(subfield.value),
            isError: this.isFieldError(subfield.dataKey),
          })),
        };
      }
    });
  }

  get formattedContainer(): { cntrNo: string }[] | null {
    if (!this.container) return null;
    if (Array.isArray(this.container)) {
      return this.container.map((cn) => ({ cntrNo: cn.cntrNo }));
    }
    return null;
  }

  get isFoundInBoth(): boolean {
    return this.opusFound && this.shineFound;
  }

  get foundText(): string {
    if (this.opusFound && this.shineFound) {
      return `Found in OPUS and SHINE`;
    } else if (this.opusFound && !this.shineFound) {
      return `Found in OPUS`;
    } else if (!this.opusFound && this.shineFound) {
      return `Found in SHINE`;
    }
    //  else if (
    //   !this.opusFound &&
    //   !this.opusError &&
    //   !this.shineFound &&
    //   !this.shineError
    // ) {
    //   return `Not found in OPUS and SHINE`;
    // } else if (
    //   !this.opusFound &&
    //   !this.opusError &&
    //   this.shineError
    // ) {
    //   return `Not found in OPUS`;
    // } else if (
    //   !this.shineFound &&
    //   !this.shineError &&
    //   this.opusError
    // ) {
    //   return `Not found in SHINE`;
    // }
    return '';
  }

  static bookingInfoSplitInfoToIsSplit(splitInfo?: string): boolean {
    return splitInfo === 'Split';
  }

  get isSplit() {
    return this.splitInfo === 'Split';
  }

  get errorText(): string {
    if (this.failedFromBothApis) {
      return `Could not connect to OPUS and SHINE APIs`;
    } else if (this.opusError || this.shineError) {
      const source = this.opusError ? 'OPUS' : 'SHINE';
      return `Could not connect to ${source} API`;
    } else if (this.isNotFound) {
      return `Booking not found ${
        envCheckers.isNonProd() && '(in TEST System)'
      }`;
    } else if (!this.opusFound || !this.shineFound) {
      const source = !this.opusFound ? 'OPUS' : 'SHINE';
      return `Booking not found from ${source} ${
        envCheckers.isNonProd() && '(in TEST System)'
      }`;
    } else if (this.isCanceled) {
      return `Booking is canceled`;
    }
    return '';
  }

  get failedFromAnyApi() {
    return this.opusError || this.shineError;
  }

  get errorFields() {
    let result: string[] = [];
    if (!this.opusError) {
      result = result.concat(this.opusFields);
    }
    if (!this.shineFields) {
      result = result.concat(this.shineFields);
    }
    return result;
  }

  get found() {
    return this.opusFound || this.shineFound;
  }

  get failedFromBothApis() {
    return this.opusError && this.shineError;
  }

  get hasNoData() {
    return this.isNotFound;
  }

  get isCanceled() {
    return (
      this.found &&
      this.bookingStatusCode &&
      this.bookingStatusCode === 'X'
    );
  }
  get isNotFound() {
    return !this.found;
  }

  get bookingStatus() {
    const mapping = {
      X: 'Cancel',
      S: 'Memo',
      A: 'Advansed', // according to the CLT api doc
      W: 'Wait',
      F: 'F',
    };
    return (
      this.bookingStatusCode &&
      mapping[this.bookingStatusCode as string]
    );
  }

  get siSourceStr() {
    const mapping = {
      M: 'EML',
      E: 'EDI',
      W: 'WEB',
      S: 'SEA',
    };
    return this.siSource && mapping[this.siSource as string];
  }
  get siKindStr() {
    const mapping = {
      O: 'Original',
      A: 'Amend',
      B: 'BL confirm',
      U: 'U-B/L Check',
      T: 'Attachment',
      M: 'Combine',
      S: 'Split',
      K: 'Return Back From Customer',
      G: 'DG Attachment',
      P: 'EL Attachment',
      '': '-',
    };
    return this.siKind && mapping[this.siKind as string];
  }

  static stringMapping = {
    Y: 'Yes',
    N: 'No',
  };

  get ESI() {
    return (
      this.esiFlg && BookingInfo.stringMapping[this.esiFlg as string]
    );
  }

  get dgShipment() {
    return (
      this.dgFlag && BookingInfo.stringMapping[this.dgFlag as string]
    );
  }

  static formatYN(text?: string) {
    return (
      text && (BookingInfo.stringMapping[text as string] || text)
    );
  }
}
